import React, { useEffect, useRef, useState } from "react";
import "./subjectBox.css";
import SubjectBox from "./SubjectBox";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import { SubjectIcon } from "../../../SubjectIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SubjBoxProps = ({ type, newSelfAssment }) => {
  const [variable, setVariable] = useState([]);
  const [isGettingData, setIsGettingData] = useState(false);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const scrollContainerRef = useRef(null);

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -500, behavior: "smooth" });
  };

  const getHWSubjectWise = async () => {
    try {
      setIsGettingData(true);
      let response = await axios.get(
        `/homework/studentSummary/get/studentId/${userId}`
      );
      response && setVariable(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };
  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsOverflowing(container.scrollWidth > container.clientWidth);
    }
  };
  const getSASubjectWise = async () => {
    try {
      setIsGettingData(true);
      let response = await axios.get(
        `/selfAssess/studentSummary/get/studentId/${userId}`
      );
      response && setVariable(response.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };
  useEffect(() => {
    setVariable([]);
    if (type == "SA") {
      getSASubjectWise();
    } else if ((type = "HW")) {
      getHWSubjectWise();
    }
  }, [newSelfAssment]);

  useEffect(() => {
    const handleResize = () => checkOverflow();
    // Delay checking to wait for DOM rendering
    const timer = setTimeout(() => checkOverflow(), 200);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [variable]);

  return (
    <div
      className="publish_summery_container gap-3 mb-2 mt-2"
      style={{
        width: "100%",
        backgroundColor: "#f2f2f2",
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      {/* Left Button - OUTSIDE scrollable container */}
      {isOverflowing && (
        <button
          type="button"
          className="btn btn-light d-flex align-items-center justify-content-center shadow"
          onClick={scrollLeft}
          style={{
            position: "sticky",
            left: 0,
            zIndex: 10,
            top: "50%",
            transform: "translateY(-50%)",
            borderRadius: "50%",
            backgroundColor: "#FDEFE3",
            width: "40px",
            height: "40px",
            border: "1px solid #4B4B4B",
          }}
        >
          <ChevronLeft color="#4B4B4B" size={24} />
        </button>
      )}

      {/* Scrollable container */}
      {isGettingData ? (
        <img
          style={{ width: "80px", height: "70px", position: "sticky" }}
          className="ongoing_loader"
          src="/gif/LoaderDot.gif"
          alt=""
        />
      ) : (
        <div
          ref={scrollContainerRef}
          className="publish_summery_container mb-4 gap-3 flex overflow-x-auto relative "
          style={{
            scrollBehavior: "smooth",
            alignItems: "center",
          }}
        >
          {variable.map((obj, index) => (
            <div key={index} className=" d-flex">
              <SubjectBox
                subname={obj?.subject?.name}
                sublogo={
                  SubjectIcon?.find((i) => i.subjectName === obj?.subject?.name)
                    ?.icon || "/subIcon/ic_png_science.png"
                }
                review={obj?.on_review}
                notStarted={obj?.not_started}
                complated={obj?.completed}
                isSelfAssessment={type == "SA"}
              />
            </div>
          ))}
        </div>
      )}

      {/* Right Button - OUTSIDE scrollable container */}
      {isOverflowing && (
        <button
          type="button"
          className="btn btn-light d-flex align-items-center justify-content-center shadow"
          onClick={scrollRight}
          style={{
            position: "sticky",
            right: 0,
            zIndex: 10,
            top: "50%",
            transform: "translateY(-50%)",
            borderRadius: "50%",
            backgroundColor: "#FDEFE3",
            width: "40px",
            height: "40px",
            border: "1px solid #4B4B4B",
          }}
        >
          <ChevronRight color="#4B4B4B" size={24} />
        </button>
      )}
    </div>
  );
};

export default SubjBoxProps;
